import type { CampaignItemWithVoice, ContentAudio, ContentWhatsApp } from '@/app/module/campaigns/types'
import { CampaignTemplateType } from '@/app/module/campaigns/types'

import { nestedActions } from './part-actions'
import type { PartVisitor } from './walk-part'
import { walkActions, walkPart } from './walk-part'

export const getCampaignAudioReferences = (item: CampaignItemWithVoice): Set<string> => {
  const filenames = new Set<string>()
  const visitor: PartVisitor = {
    audio: (content) => collectAudio(filenames, content),
    whatsapp: (content) => collectWhatsApp(filenames, content),
  }

  if (item.type === CampaignTemplateType.VoiceSurvey) {
    collectAudio(filenames, item.variables.welcome)
    walkActions(nestedActions(item.variables.callResultActions), visitor)
    walkActions(nestedActions(item.variables.reconnectActions), visitor)
  }

  walkActions(item.variables.onTransferFailed?.actions, visitor)
  item.variables.parts.forEach((part) => walkPart(part, visitor))
  return filenames
}

const addFile = (filenames: Set<string>, filename?: string | null) => {
  if (filename) filenames.add(filename)
}

const collectAudio = (filenames: Set<string>, content?: ContentAudio | null) => {
  addFile(filenames, content?.playfile)
  Object.values(content?.translations || {}).forEach((translation) => addFile(filenames, translation.playfile))
}

const collectWhatsApp = (filenames: Set<string>, content: ContentWhatsApp) => {
  addFile(filenames, content.audio)
  addFile(filenames, content.document)
  addFile(filenames, content.image)
  addFile(filenames, content.video)
  Object.values(content.translations || {}).forEach((translation) => {
    addFile(filenames, translation.audio)
    addFile(filenames, translation.document)
    addFile(filenames, translation.image)
    addFile(filenames, translation.video)
  })
}
